// extracted by mini-css-extract-plugin
export var copyright_priavcy = "Footer-module--copyright_priavcy---4CFV";
export var footer = "Footer-module--footer--WuQ2f";
export var logo_container = "Footer-module--logo_container--EKfbR";
export var signup = "Footer-module--signup--+VrTO";
export var white_text = "Footer-module--white_text--R+MUN";